import { Action } from '@ngrx/store';

import { ContactUsPayload } from './types/contact-us.state.type';

export enum ContactUsActionTypes {
  CONTACT_US_SUBMIT_REQUESTED = '[Contact Us] Contact Us Requested',
  CONTACT_US_SUBMIT_SUCCEEDED = '[Contact Us] Contact Us Succeeded',
  CONTACT_US_SUBMIT_FAILED = '[Contact Us] Contact Us Failed',
}

export class ContactUsRequested implements Action {
  readonly type = ContactUsActionTypes.CONTACT_US_SUBMIT_REQUESTED;
  constructor(public payload: ContactUsPayload) {}
}

export class ContactUsSucceeded implements Action {
  readonly type = ContactUsActionTypes.CONTACT_US_SUBMIT_SUCCEEDED;
}

export class ContactUsFailed implements Action {
  readonly type = ContactUsActionTypes.CONTACT_US_SUBMIT_FAILED;
}

export type ContactUsActionsUnion =
  | ContactUsRequested
  | ContactUsSucceeded
  | ContactUsFailed;
